import { gql } from 'graphql-tag';

export default gql`
  query GetCustomerStats($accountId: Int!) {
    getCustomerStats(account_id: $accountId) {
      totalCustomers {
        value
        change
        changeText
        isPositive
      }
      avgLifetimeValue {
        value
        change
        changeText
        isPositive
      }
      avgEventsPerCustomer {
        value
        change
        changeText
        isPositive
      }
      avgCustomersPerEvent {
        value
        change
        changeText
        isPositive
      }
      superFans {
        value
        change
        changeText
        isPositive
      }
    }
  }
`;
